/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { createTheme } from '@mui/material/styles';
import { snackbarClasses, buttonBaseClasses, alertClasses, paperClasses, svgIconClasses, formControlLabelClasses, formControlClasses, formHelperTextClasses, filledInputClasses, inputAdornmentClasses, typographyClasses, inputBaseClasses, selectClasses, chipClasses, listClasses, menuItemClasses, inputLabelClasses, iconButtonClasses, stepLabelClasses, stepConnectorClasses, stepContentClasses, linearProgressClasses, } from '@mui/material';
import TaskAltOutlinedIcon from '@mui/icons-material/TaskAltOutlined';
import { colorPalette } from './colorPalette';
import { ChevronDownOutlined, WarningOutlined, InfoOutlined, Close as CloseNextCommon } from '@rakutenfrance/material-ui-icons';
import IconButton from '@mui/material/IconButton';
import Check from '@mui/icons-material/Check';
import Close from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import Box from '@mui/material/Box';
import { RadioButtonIcon } from './components/RadioButtonIcon';
import { calendarPickerClasses } from '@mui/x-date-pickers';
import { calendarOrClockPickerClasses, pickersPopperClasses } from '@mui/x-date-pickers/internals';
export const globalTheme = (color, htmlFontSize = 10, _pxToRem) => {
    const colorArray = {
        main: colorPalette.red800, // Default
        border: colorPalette.red800,
        secondary: colorPalette.red700, // Hover & Focus
        third: colorPalette.red900, // Active
        backgroundOutlinedHover: colorPalette.red200, // Background main Hover
        backgroundOutlinedActive: colorPalette.red300, // Background main active
        backgroundTextHover: colorPalette.red100, // Background main Hover
        backgroundTextActive: colorPalette.red200, // Background main active
        text: colorPalette.white, // Contained Text
        textSecondary: colorPalette.red800, // Secondary (hover) Text
        outlined: colorPalette.red800, // Outlined color (text, border)
    };
    if (color === 'green') {
        colorArray.main = colorPalette.green700;
        colorArray.border = colorPalette.green700;
        colorArray.secondary = colorPalette.green600;
        colorArray.third = colorPalette.green800;
        colorArray.backgroundOutlinedHover = colorPalette.green200;
        colorArray.backgroundOutlinedActive = colorPalette.green300;
        colorArray.backgroundTextHover = colorPalette.green100;
        colorArray.backgroundTextActive = colorPalette.green200;
        colorArray.textSecondary = colorPalette.green700;
        colorArray.outlined = colorPalette.green700;
    }
    else if (color === 'tertiary') {
        colorArray.main = colorPalette.gray200;
        colorArray.secondary = colorPalette.gray300;
        colorArray.third = colorPalette.gray400;
        colorArray.border = colorPalette.gray800;
        colorArray.text = colorPalette.gray900;
        colorArray.textSecondary = colorPalette.gray800;
        colorArray.outlined = colorPalette.gray700;
        colorArray.backgroundOutlinedHover = colorPalette.gray100;
        colorArray.backgroundOutlinedActive = colorPalette.gray200;
        colorArray.backgroundTextHover = colorPalette.gray100;
        colorArray.backgroundTextActive = colorPalette.gray200;
    }
    const fontSize = 14; // px
    // Tell Material-UI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    const coef = fontSize / 14;
    let pxToRem = (size) => `${(size / htmlFontSize) * coef}rem`;
    if (_pxToRem) {
        pxToRem = _pxToRem;
    }
    const theme = {
        pxToRemUtils: pxToRem,
        typography: {
            // @ts-expect-error Theme pxToRem not definde in options
            pxToRem,
            htmlFontSize,
            fontFamily: ['RakutenSansUi', 'RakutenSansUiBlack', 'RakutenSansUiLight', 'RakutenSansUiSemiBold', 'sans-serif'].join(','),
            fontWeightMedium: 600,
            h1: {
                fontSize: pxToRem(24),
                fontWeight: 400,
                lineHeight: 1.208,
            },
            h2: {
                fontSize: pxToRem(20),
                fontWeight: 400,
                lineHeight: 1.2,
            },
            h3: {
                fontSize: pxToRem(18),
                fontWeight: 700,
                lineHeight: 1.056,
            },
            body1: {
                fontSize: pxToRem(14),
                lineHeight: 1.214,
            },
            body2: {
                fontSize: pxToRem(14),
                lineHeight: 1.214,
            },
            button: {
                textTransform: 'none',
            },
        },
        shadows: [
            'none',
            'none',
            'none',
            'none',
            'none',
            'none',
            'none',
            'none',
            'none',
            'none',
            'none',
            'none',
            'none',
            'none',
            'none',
            'none',
            'none',
            'none',
            'none',
            'none',
            'none',
            'none',
            'none',
            'none',
            'none',
        ],
        breakpoints: {
            values: {
                // breakpoint naming used from material-ui
                xs: 0, // material-ui standard 0
                sm: 576, // material-ui modified 600
                ta: 768, // Custom rakuten-grid tablet
                md: 992, // material-ui modified 960
                lg: 1200, // material-ui modified 1280
                ew: 1366, // Custom  nav&search
                llg: 1440, // Custom  product image
                hd: 1536, // Custom product image with kameleoon
                xl: 1920, // material-ui modified 1920
            },
        },
        palette: {
            common: {
                black: colorPalette.gray1000,
                white: colorPalette.white,
            },
            primary: {
                main: colorArray.main,
                dark: colorArray.secondary,
                contrastText: colorPalette.white,
            },
            secondary: {
                main: colorPalette.gray1000,
                dark: colorPalette.gray900,
                contrastText: colorPalette.white,
            },
            tertiary: {
                main: colorPalette.gray200,
                dark: colorPalette.gray300,
                contrastText: colorPalette.gray1000,
            },
            black: {
                main: colorPalette.gray1000,
                dark: colorPalette.gray900,
                contrastText: colorPalette.white,
            },
            gray: {
                main: colorPalette.gray500,
                dark: colorPalette.gray300,
                contrastText: colorPalette.white,
            },
            red: {
                main: colorPalette.red700,
                dark: colorPalette.red600,
                contrastText: colorPalette.white,
            },
            seller: {
                main: colorPalette.green700,
                dark: colorPalette.green600,
                contrastText: colorPalette.white,
            },
            error: {
                main: colorPalette.red600,
            },
            info: {
                main: colorPalette.lightBlue800,
            },
            success: {
                main: colorPalette.green800,
            },
            warning: {
                main: colorPalette.orange800,
            },
            background: {
                default: colorPalette.white,
            },
            action: {
                disabled: colorPalette.white,
                disabledBackground: colorPalette.gray700,
            },
            text: {
                primary: colorPalette.gray1000,
                secondary: colorPalette.gray700,
                disabled: colorPalette.gray900
            },
        },
        components: {
            MuiButton: {
                styleOverrides: {
                    /***
                     *
                     */
                    root: ({ ownerState }) => (Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ borderRadius: '4px', lineHeight: 1, fontSize: `${pxToRem(14)}`, 
                        /***
                         *
                         */
                        '&.Mui-disabled': {
                            color: colorPalette.white,
                            borderColor: colorPalette.gray300,
                            backgroundColor: colorPalette.gray300,
                            cursor: 'not-allowed',
                            pointerEvents: 'all',
                            '&:hover, &:active, &.Mui-focused, &.Mui-focused &.Mui-focused:active': {
                                color: colorPalette.white,
                                borderColor: colorPalette.gray300,
                                backgroundColor: colorPalette.gray300,
                            },
                        } }, (ownerState.variant === 'contained' &&
                        ownerState.color === 'seller' && {
                        '&:active, &.Mui-focused:active': {
                            borderColor: colorPalette.green800,
                            backgroundColor: colorPalette.green800,
                        },
                    })), (ownerState.variant === 'contained' &&
                        ownerState.color === 'tertiary' && {
                        color: colorPalette.gray900,
                        borderColor: colorPalette.gray200,
                        backgroundColor: colorPalette.gray200,
                        '&:hover': {
                            borderColor: colorPalette.gray300,
                            backgroundColor: colorPalette.gray300,
                        },
                        '&:active': {
                            borderColor: colorPalette.gray400,
                            backgroundColor: colorPalette.gray400,
                        },
                        '&.Mui-focused': {
                            borderColor: colorPalette.white,
                            backgroundColor: colorPalette.gray200,
                            '&:active': {
                                borderColor: colorPalette.gray400,
                                backgroundColor: colorPalette.gray400,
                            },
                        },
                    })), (ownerState.variant === 'outlined' &&
                        ownerState.color === 'seller' && {
                        borderColor: colorPalette.green700,
                        '&:hover, &.Mui-focused:active': {
                            backgroundColor: colorPalette.green200,
                        },
                        '&:active': {
                            backgroundColor: colorPalette.green300,
                        },
                    })), (ownerState.variant === 'outlined' &&
                        ownerState.color === 'tertiary' && {
                        color: colorPalette.gray700,
                        borderColor: colorPalette.gray700,
                        backgroundColor: colorPalette.transparent,
                        '&:hover': {
                            color: colorPalette.gray800,
                            borderColor: colorPalette.gray800,
                            backgroundColor: colorPalette.gray100,
                        },
                        '&:active': {
                            color: colorPalette.gray800,
                            borderColor: colorPalette.gray800,
                            backgroundColor: colorPalette.gray200,
                        },
                        '&.Mui-focused': {
                            color: colorPalette.gray700,
                            borderColor: colorPalette.gray700,
                            backgroundColor: colorPalette.transparent,
                            '&:active': {
                                color: colorPalette.gray800,
                                borderColor: colorPalette.gray800,
                                backgroundColor: colorPalette.gray200,
                            },
                        },
                    })), (ownerState.variant === 'text' &&
                        ownerState.color === 'seller' && {
                        '&:hover': {
                            backgroundColor: colorPalette.green100,
                        },
                        '&:active': {
                            backgroundColor: colorPalette.green200,
                        },
                        '&.Mui-focused': {
                            '&:active': {
                                backgroundColor: colorPalette.green200,
                            },
                        },
                    })), (ownerState.variant === 'text' &&
                        ownerState.color === 'tertiary' && {
                        color: colorPalette.gray700,
                        '&:hover': {
                            backgroundColor: colorPalette.gray100,
                        },
                        '&:active': {
                            backgroundColor: colorPalette.gray200,
                        },
                        '&.Mui-focused': {
                            '&:active': {
                                backgroundColor: colorPalette.gray200,
                            },
                        },
                    }))),
                    /***
                     *
                     * CONTAINED
                     */
                    containedPrimary: {
                        color: colorArray.text,
                        borderColor: colorArray.border,
                        backgroundColor: colorArray.main,
                        '&:hover': {
                            borderColor: colorArray.secondary,
                            backgroundColor: colorArray.secondary,
                        },
                        '&:active': {
                            borderColor: colorArray.third,
                            backgroundColor: colorArray.third,
                        },
                        '&.Mui-focused': {
                            borderColor: colorArray.main,
                            backgroundColor: colorArray.main,
                            '&:active': {
                                borderColor: colorArray.third,
                                backgroundColor: colorArray.third,
                            },
                        },
                    },
                    containedSecondary: {
                        color: colorArray.text,
                        borderColor: colorPalette.gray1000,
                        backgroundColor: colorPalette.gray1000,
                        '&:hover': {
                            borderColor: colorPalette.gray800,
                            backgroundColor: colorPalette.gray800,
                        },
                        '&:active': {
                            borderColor: colorPalette.gray900,
                            backgroundColor: colorPalette.gray900,
                        },
                        '&.Mui-focused': {
                            borderColor: colorPalette.gray1000,
                            backgroundColor: colorPalette.gray1000,
                            '&:active': {
                                borderColor: colorPalette.gray900,
                                backgroundColor: colorPalette.gray900,
                            },
                        },
                    },
                    /***
                     *
                     * OUTLINED
                     */
                    outlinedPrimary: {
                        color: colorArray.outlined,
                        borderColor: colorArray.outlined,
                        backgroundColor: colorPalette.transparent,
                        '&:hover': {
                            color: colorArray.textSecondary,
                            borderColor: colorArray.border,
                            backgroundColor: colorArray.backgroundOutlinedHover,
                        },
                        '&:active': {
                            color: colorArray.textSecondary,
                            borderColor: colorArray.border,
                            backgroundColor: colorArray.backgroundOutlinedActive,
                        },
                        '&.Mui-focused': {
                            '&:active': {
                                color: colorArray.textSecondary,
                                borderColor: colorArray.border,
                                backgroundColor: colorArray.backgroundOutlinedActive,
                            },
                        },
                    },
                    outlinedSecondary: {
                        color: colorPalette.gray1000,
                        borderColor: colorPalette.gray1000,
                        backgroundColor: colorPalette.transparent,
                        '&:hover': {
                            backgroundColor: colorPalette.gray200,
                        },
                        '&:active': {
                            backgroundColor: colorPalette.gray300,
                        },
                        '&.Mui-focused': {
                            '&:active': {
                                backgroundColor: colorPalette.gray300,
                            },
                        },
                    },
                    /***
                     *
                     * TEXT
                     */
                    textPrimary: {
                        color: colorArray.outlined,
                        '&:hover': {
                            backgroundColor: colorArray.backgroundTextHover,
                        },
                        '&:active': {
                            backgroundColor: colorArray.backgroundTextActive,
                        },
                        '&.Mui-focused': {
                            '&:active': {
                                backgroundColor: colorArray.backgroundTextActive,
                            },
                        },
                    },
                    textSecondary: {
                        '&:hover': {
                            backgroundColor: colorPalette.gray100,
                        },
                        '&:active': {
                            backgroundColor: colorPalette.gray200,
                        },
                        '&.Mui-focused': {
                            '&:active': {
                                backgroundColor: colorPalette.gray200,
                            },
                        },
                    },
                    /****
                     *
                     *
                     * Sizes
                     */
                    contained: {
                        padding: `${pxToRem(11)} ${pxToRem(12)}`,
                    },
                    outlined: {
                        padding: `${pxToRem(11)} ${pxToRem(12)}`,
                    },
                    text: {
                        padding: `${pxToRem(11)} ${pxToRem(12)}`,
                    },
                    containedSizeLarge: {
                        padding: `${pxToRem(15)} ${pxToRem(16)}`,
                    },
                    outlinedSizeLarge: {
                        padding: `${pxToRem(15)} ${pxToRem(16)}`,
                    },
                    textSizeLarge: {
                        padding: `${pxToRem(15)} ${pxToRem(16)}`,
                    },
                    containedSizeSmall: {
                        padding: `${pxToRem(7)} ${pxToRem(8)}`,
                    },
                    outlinedSizeSmall: {
                        padding: `${pxToRem(7)} ${pxToRem(8)}`,
                    },
                    textSizeSmall: {
                        padding: `${pxToRem(7)} ${pxToRem(8)}`,
                    },
                },
            },
            MuiCheckbox: {
                styleOverrides: {
                    colorPrimary: {
                        color: colorPalette.gray500,
                    },
                    root: {
                        padding: '0px',
                        margin: '0px 8px 0px 8px',
                        '&.MuiCheckbox-LabelPlacement-start': {
                            paddingRight: 0.5,
                        },
                        '& .MuiSvgIcon-root': {
                            width: '16px',
                            height: '16px',
                        },
                        '&.MuiCheckbox-colorError': {
                            color: colorPalette.red600,
                            '&.MuiCheckbox-indeterminate': {
                                color: colorPalette.red600,
                            },
                        },
                        '&.Mui-checked': {
                            color: colorPalette.gray1000,
                        },
                        '&.MuiCheckbox-indeterminate': {
                            color: colorPalette.gray1000,
                        },
                        '&:focus': {
                            backgroundColor: 'transparent',
                            borderRadius: '2px',
                            boxShadow: `inset 0 0 0 1px ${colorPalette.lightBlue800}`,
                        },
                        '&:active': {
                            backgroundColor: 'transparent',
                            borderRadius: '2px',
                            boxShadow: `inset 0 0 0 3px ${colorPalette.gray200}, 0 0 0 2px ${colorPalette.gray200}`,
                        },
                        '&:hover': {
                            backgroundColor: 'transparent',
                            borderRadius: '2px',
                            boxShadow: `inset 0 0 0 3px ${colorPalette.gray100}, 0 0 0 2px ${colorPalette.gray100}`,
                        },
                        '&.Mui-disabled': {
                            color: colorPalette.gray400,
                        },
                    },
                },
                defaultProps: {
                    color: 'primary',
                },
            },
            MuiSwitch: {
                styleOverrides: {
                    root: {
                        height: 22,
                        padding: 0,
                        width: 40,
                        overflow: 'visible',
                    },
                    switchBase: {
                        margin: '1px 2px',
                        padding: '2px',
                        transform: 'translateX(0px)',
                        transition: 'background-color 150ms ease-out, left 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
                        '&.Mui-checked': {
                            transform: 'translateX(16px)',
                            '& + .V5Switch-track, & + .MuiSwitch-track': {
                                opacity: 1,
                                backgroundColor: colorPalette.gray1000,
                            },
                        },
                        '&.Mui-disabled': {
                            cursor: 'not-allowed',
                            pointerEvents: 'all',
                            '& > div': {
                                color: colorPalette.gray700,
                                backgroundColor: colorPalette.gray100,
                            },
                            '& + .V5Switch-track, & + .MuiSwitch-track': {
                                opacity: 1,
                                backgroundColor: colorPalette.gray200,
                            },
                        },
                        '&:hover': {
                            backgroundColor: colorPalette.gray200,
                            '&.Mui-checked': {
                                backgroundColor: colorPalette.gray900,
                            },
                        },
                        '&:active': {
                            '& > div': {
                                borderRadius: '8px',
                                transition: 'all 150ms ease-out',
                                width: 20,
                            },
                            '&.Mui-checked': {
                                transform: 'translateX(12px)',
                            },
                        },
                        '&:focus + .V5Switch-track, &:focus + .MuiSwitch-track': {
                            outline: `1px solid ${colorPalette.lightBlue800}`,
                            border: `1px solid ${colorPalette.white}`,
                        },
                    },
                    track: {
                        backgroundColor: colorPalette.gray300,
                        borderRadius: '16px',
                        opacity: 1,
                        outline: 'none',
                    },
                    thumb: {
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    },
                },
                defaultProps: {
                    disableRipple: true,
                    icon: (React.createElement(Box, { sx: {
                            alignItems: 'center',
                            backgroundColor: colorPalette.white,
                            borderRadius: '50%',
                            color: colorPalette.gray1000,
                            display: 'flex',
                            height: 16,
                            justifyContent: 'center',
                            width: 16,
                        } },
                        React.createElement(Close, { sx: { height: '12px', width: '12px' } }))),
                    checkedIcon: (React.createElement(Box, { sx: {
                            alignItems: 'center',
                            backgroundColor: colorPalette.white,
                            borderRadius: '50%',
                            color: colorPalette.gray1000,
                            display: 'flex',
                            height: 16,
                            justifyContent: 'center',
                            width: 16,
                        } },
                        React.createElement(Check, { sx: { height: '12px', width: '12px' } }))),
                },
            },
            MuiRadio: {
                styleOverrides: {
                    root: ({ ownerState }) => (Object.assign({ padding: '4px', '& svg': {
                            borderRadius: '50%',
                            backgroundColor: colorPalette.white,
                        }, '&:focus': {
                            '&:after': {
                                content: `""`,
                                position: 'absolute',
                                height: '20px',
                                width: '20px',
                                border: `1px solid ${colorPalette.blue500}`,
                                borderRadius: '50%',
                            },
                        } }, (ownerState.color === 'error' && {
                        color: colorPalette.red600,
                        '&.Mui-checked': {
                            color: colorPalette.gray1000,
                            '& svg': {
                                borderRadius: '50%',
                                border: `1px solid ${colorPalette.red600}`,
                                borderColor: colorPalette.red600,
                                backgroundColor: colorPalette.white,
                            },
                        },
                    }))),
                    colorPrimary: {
                        color: colorPalette.gray500,
                        '&.Mui-disabled': {
                            color: colorPalette.gray500,
                            '& svg': {
                                backgroundColor: colorPalette.gray200,
                            },
                            '&.Mui-checked': {
                                color: colorPalette.gray400,
                                '& svg': {
                                    border: `1px solid ${colorPalette.gray400}`,
                                    backgroundColor: colorPalette.white,
                                },
                            },
                        },
                        '&.Mui-checked': {
                            color: colorPalette.gray1000,
                            '&:hover svg': {
                                color: colorPalette.gray1000,
                            },
                            '& svg': {
                                border: `1px solid ${colorPalette.gray1000}`,
                            },
                        },
                        '&:hover': {
                            color: colorPalette.gray500,
                            backgroundColor: colorPalette.gray100,
                        },
                        '&:active': {
                            color: colorPalette.gray500,
                            backgroundColor: colorPalette.gray200,
                        },
                    },
                },
                defaultProps: {
                    color: 'primary',
                    icon: React.createElement(RadioButtonIcon, { checked: false }),
                    checkedIcon: React.createElement(RadioButtonIcon, { checked: true }),
                },
            },
            MuiFilledInput: {
                styleOverrides: {
                    input: {
                        height: 'auto',
                        [`&:not(&:has(.${chipClasses.root}))&:not(textarea)`]: {
                            maxHeight: '48px',
                        },
                        padding: `${pxToRem(15)} ${pxToRem(16)} ${pxToRem(15)} ${pxToRem(16)}`,
                        color: colorPalette.gray900,
                        [`&:has(.${selectClasses.select})`]: {
                            maxHeight: 'none',
                            minHeight: '48px',
                        },
                    },
                    root: {
                        border: `1px solid ${colorPalette.gray300}`,
                        borderRadius: '4px',
                        '@media (max-width:576px)': {
                            fontSize: pxToRem(16),
                        },
                        backgroundColor: colorPalette.white,
                        color: colorPalette.gray800,
                        '&:hover': {
                            backgroundColor: colorPalette.white,
                            borderColor: colorPalette.gray1000,
                        },
                        '&.Mui-focused': {
                            backgroundColor: colorPalette.white,
                            borderColor: colorPalette.gray1000,
                        },
                        '&.Mui-disabled': {
                            backgroundColor: colorPalette.gray100,
                            '&:hover': {
                                borderColor: colorPalette.gray300,
                            },
                        },
                        '&.Mui-error': {
                            borderColor: colorPalette.red600,
                            color: colorPalette.gray800,
                        },
                        '&:hover:not(.Mui-disabled):not(.Mui-focused)': {
                            borderColor: colorPalette.gray300,
                            boxShadow: `0px 0px 0px 4px ${colorPalette.gray100}`,
                            transition: 'linear 0.05s',
                        },
                        '&:active': {
                            borderColor: colorPalette.gray800,
                            boxShadow: `0px 0px 0px 4px ${colorPalette.gray100}`,
                        },
                        '&:focus': {
                            borderColor: colorPalette.gray300,
                            boxShadow: `0px 0px 0px 1px ${colorPalette.blue500}`,
                        },
                        [`&:has(.${selectClasses.select}) .${svgIconClasses.root}`]: {
                            color: colorPalette.gray700,
                            position: 'relative',
                            right: 0,
                            marginRight: '12px',
                        },
                    },
                },
                defaultProps: {
                    disableUnderline: true,
                },
            },
            MuiInputLabel: {
                styleOverrides: {
                    root: {
                        paddingLeft: '0.7rem',
                        color: colorPalette.gray500,
                        '&.Mui-focused': {
                            color: colorPalette.gray500,
                        },
                        '&.Mui-disabled': {
                            color: colorPalette.gray400,
                        },
                        '&.Mui-error': {
                            color: colorPalette.gray500,
                        },
                        fontSize: `${pxToRem(14)}`,
                    },
                    filled: {
                        color: colorPalette.gray700,
                        fontSize: `${pxToRem(14)}`,
                        [`&.${inputLabelClasses.shrink}`]: {
                            transform: 'translate(12px, 8px) scale(0.71)',
                            color: colorPalette.gray700,
                        },
                    },
                },
            },
            MuiSelect: {
                styleOverrides: {
                    select: {
                        boxSizing: 'border-box',
                        borderRadius: '4px',
                        backgroundColor: colorPalette.white,
                        minHeight: '48px',
                        '& .MuiBox-root': {
                            display: 'flex',
                            flexWrap: 'wrap',
                        },
                        [`:has(.${chipClasses.root})`]: {
                            padding: `${pxToRem(6)} ${pxToRem(16)}`,
                        },
                        [`& .${chipClasses.root}`]: {
                            margin: `${pxToRem(2)}`,
                        },
                        '&.Mui-disabled': {
                            backgroundColor: colorPalette.gray100,
                            borderColor: colorPalette.gray400,
                        },
                        [`& .${typographyClasses.root}`]: {
                            color: colorPalette.gray500,
                        },
                    },
                    icon: {
                        top: 'calc(50% - 7px)',
                        '&.Mui-disabled': {
                            color: colorPalette.gray600,
                        },
                    },
                    iconFilled: {
                        right: 12,
                    },
                },
                defaultProps: {
                    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
                    IconComponent: (props) => React.createElement(ChevronDownOutlined, Object.assign({ style: { width: 16, height: 16 } }, props)),
                },
            },
            MuiMenuItem: {
                styleOverrides: {
                    root: {
                        '&.Mui-selected': {
                            backgroundColor: colorPalette.gray200,
                            '&:hover': {
                                backgroundColor: colorPalette.gray200,
                            },
                        },
                    },
                },
            },
            MuiFormHelperText: {
                styleOverrides: {
                    root: {
                        textAlign: 'left',
                        marginLeft: '1rem',
                        marginTop: 0,
                        '&.MuiCheckbox-errorLabelPlacement-start': {
                            textAlign: 'right',
                            marginLeft: '0.8rem',
                            marginTop: 0,
                            marginRight: 0,
                        },
                        '&.MuiCheckboxGroup-title': {
                            fontWeight: 600,
                            fontSize: `${pxToRem(16)}`,
                            lineHeight: `${pxToRem(20)}`,
                            color: colorPalette.gray800,
                        },
                        '&.MuiCheckboxGroup-error': {
                            marginTop: 8,
                        },
                    },
                    contained: {
                        marginRight: 0,
                    },
                },
            },
            MuiFormControlLabel: {
                styleOverrides: {
                    root: ({ ownerState }) => (Object.assign(Object.assign({ display: 'flex', verticalAlign: 'top', marginLeft: 0, marginBottom: '0', marginTop: 16 }, (ownerState.labelPlacement === 'start' && {
                        justifyContent: 'start',
                        paddingLeft: '1rem',
                    })), { '& .MuiFormControlLabel-label.Mui-disabled': {
                            color: colorPalette.gray700,
                        }, [`&.${formControlLabelClasses.labelPlacementStart} .MuiFormControlLabel-label`]: {
                            textAlign: 'right',
                        } })),
                },
            },
            MuiAlert: {
                styleOverrides: {
                    root: {
                        display: 'flex',
                        padding: '0.8rem',
                        paddingTop: 0,
                        paddingBottom: 0,
                    },
                    message: {
                        width: '100%',
                        lineHeight: '1.8rem',
                    },
                    icon: {
                        padding: 0,
                        margin: 0,
                        marginRight: 8,
                        marginTop: 8,
                        height: 16,
                        width: 16,
                        marginBottom: '0px !important',
                    },
                    action: {
                        marginBottom: '0px !important',
                        padding: 0,
                        height: 16,
                        width: 16,
                        marginRight: 8,
                        marginTop: 2,
                        marginLeft: 8,
                        fontWeight: 'inherit',
                        [`.${buttonBaseClasses.root}`]: {
                            color: 'inherit',
                            paddingRight: 3,
                            padding: '7px',
                        },
                    },
                    standardInfo: {
                        color: colorPalette.lightBlue800,
                        backgroundColor: colorPalette.lightBlue100,
                        '& [data-qa="link-url"]': {
                            color: colorPalette.lightBlue800,
                            '& div > span': {
                                textDecorationColor: `${colorPalette.lightBlue800}66`,
                            },
                        },
                    },
                    standardSuccess: {
                        color: colorPalette.green800,
                        backgroundColor: colorPalette.green100,
                        '& [data-qa="link-url"]': {
                            color: colorPalette.green800,
                            '& div > span': {
                                textDecorationColor: `${colorPalette.green800}66`,
                            },
                        },
                    },
                    standardError: {
                        color: colorPalette.red800,
                        backgroundColor: colorPalette.red100,
                        [`&.${alertClasses.icon}`]: {
                            color: colorPalette.red800,
                        },
                        '& [data-qa="link-url"]': {
                            color: colorPalette.red800,
                            '& div > span': {
                                textDecorationColor: `${colorPalette.red800}66`,
                            },
                        },
                    },
                    standardWarning: {
                        color: colorPalette.orange800,
                        backgroundColor: colorPalette.orange100,
                        '& [data-qa="link-url"]': {
                            color: colorPalette.orange800,
                            '& div > span': {
                                textDecorationColor: `${colorPalette.orange800}66`,
                            },
                        },
                    },
                },
                defaultProps: {
                    variant: 'standard',
                    action: (React.createElement(IconButton, { color: "inherit", size: "small" },
                        React.createElement(CloseNextCommon, { style: { width: 16, height: 16 } }))),
                    iconMapping: {
                        success: React.createElement(TaskAltOutlinedIcon, { style: { width: 16, height: 16 } }),
                        info: React.createElement(InfoOutlined, { style: { width: 16, height: 16 } }),
                        error: React.createElement(WarningOutlined, { style: { width: 16, height: 16 } }),
                        warning: React.createElement(WarningOutlined, { style: { width: 16, height: 16 } }),
                    },
                },
            },
            MuiAlertTitle: {
                styleOverrides: {
                    root: {
                        paddingTop: 2,
                        fontWeight: 700,
                        marginBottom: 2,
                    },
                },
            },
            MuiSvgIcon: {
                styleOverrides: {
                    fontSizeSmall: {
                        fontSize: '16px',
                    },
                    colorPrimary: {
                        color: colorPalette.gray1000,
                    },
                    colorSecondary: {
                        color: colorPalette.red600,
                    },
                },
            },
            MuiIconButton: {
                styleOverrides: {
                    root: {
                        color: colorPalette.gray800,
                        '&:hover': {
                            backgroundColor: 'transparent',
                        },
                    },
                },
            },
            MuiButtonBase: {
                defaultProps: {
                    disableRipple: true,
                },
            },
            MuiTextField: {
                styleOverrides: {
                    root: {
                        '&.Mui-disabled': {
                            backgroundColor: colorPalette.gray100,
                            borderColor: colorPalette.gray400,
                        },
                    }
                },
                defaultProps: {
                    variant: 'filled',
                    margin: 'dense',
                    fullWidth: true,
                },
            },
            MuiFormControl: {
                defaultProps: {
                    variant: 'filled',
                    fullWidth: true,
                },
                styleOverrides: {
                    root: {
                        [`${formControlClasses.root}`]: {
                            color: colorPalette.gray700,
                        },
                        [`&:has(.${selectClasses.select}):has(.${chipClasses.root})`]: {
                            [`& .${inputLabelClasses.root}`]: {
                                display: 'none',
                            },
                        },
                        [`& .${inputLabelClasses.formControl}`]: {
                            color: colorPalette.gray700,
                        },
                        [`& .${formHelperTextClasses.root}`]: {
                            marginTop: '4px',
                            '& > *:not(:first-of-type)': {
                                marginTop: '4px',
                            },
                        },
                        [`& .${inputAdornmentClasses.root}`]: {
                            '& .MuiIconButton-root.Mui-disabled': {
                                color: colorPalette.gray300,
                            },
                            [`.${iconButtonClasses.root}`]: {
                                paddingRight: '16px',
                                color: colorPalette.gray800,
                                fontSize: '24px',
                            },
                        },
                        [`& .${inputBaseClasses.multiline}`]: {
                            padding: 0,
                            position: 'relative',
                            [`& .${inputAdornmentClasses.positionEnd}`]: {
                                position: 'absolute',
                                bottom: 10,
                                right: 0,
                                [`& .${typographyClasses.caption}`]: {
                                    color: colorPalette.gray700,
                                    padding: `${pxToRem(0)} ${pxToRem(16)} ${pxToRem(8)} ${pxToRem(0)}`,
                                },
                            },
                        },
                        [`&:has(.${filledInputClasses.root}):has(.${selectClasses.select})`]: {
                            [`& .${formHelperTextClasses.root}`]: {
                                marginLeft: 0,
                                fontSize: '12px',
                                color: colorPalette.gray800,
                                '&.Mui-error': {
                                    color: colorPalette.red600,
                                },
                            },
                        },
                        [`&:has(.${inputLabelClasses.shrink})`]: {
                            [`& .${filledInputClasses.input}`]: {
                                padding: `${pxToRem(21)} ${pxToRem(16)} ${pxToRem(9)} ${pxToRem(16)}`,
                            },
                        },
                    },
                },
            },
            MuiChip: {
                styleOverrides: {
                    outlined: {
                        backgroundColor: colorPalette.white,
                        '&.Mui-disabled': {
                            color: colorPalette.gray400,
                            backgroundColor: colorPalette.gray200,
                            border: `1px solid ${colorPalette.gray300}`,
                        },
                        '&.MuiChip-selected': {
                            backgroundColor: `${colorPalette.gray100} !important`,
                            color: colorPalette.gray800,
                            border: `1px solid ${colorPalette.gray700}`,
                            '& .MuiChip-deleteIcon, & .MuiChip-icon': {
                                color: 'inherit',
                            },
                        },
                        '&:hover': {
                            backgroundColor: colorPalette.gray100,
                        },
                        '&:active': {
                            backgroundColor: `${colorPalette.gray200} !important`,
                        },
                    },
                    root: ({ ownerState }) => ({
                        color: colorPalette.gray800,
                        backgroundColor: colorPalette.gray100,
                        '& .MuiChip-deleteIcon, & .MuiChip-icon': {
                            // Width and height of icons may change
                            width: ownerState.size === 'small' ? 16 : 24,
                            height: ownerState.size === 'small' ? 16 : 24,
                        },
                        '&.Mui-disabled': {
                            color: colorPalette.gray400,
                            backgroundColor: colorPalette.gray200,
                            opacity: 1,
                        },
                        '&.MuiChip-selected': {
                            color: colorPalette.white,
                            backgroundColor: `${colorPalette.gray700} !important`,
                            '& .MuiChip-deleteIcon, & .MuiChip-icon': {
                                color: colorPalette.white,
                            },
                        },
                        '&:hover': {
                            backgroundColor: colorPalette.gray200,
                        },
                        '&:active': {
                            backgroundColor: `${colorPalette.gray300} !important`,
                        },
                        '&:focus': {
                            boxShadow: `0 0 0 1px ${colorPalette.white}, 0 0 0 2px ${colorPalette.blue500}`,
                        },
                    }),
                },
                defaultProps: {
                    variant: 'filled',
                    size: 'medium',
                },
            },
            MuiSkeleton: {
                styleOverrides: {
                    root: {
                        backgroundColor: colorPalette.gray200,
                        '&.display1': {
                            height: '60px',
                        },
                        '&.display2': {
                            height: '50px',
                        },
                        '&.display3': {
                            height: '40px',
                        },
                        '&.heading1': {
                            height: '30px',
                        },
                        '&.heading2': {
                            height: '25px',
                        },
                        '&.heading3': {
                            height: '23px',
                        },
                        '&.heading4': {
                            height: '20px',
                        },
                        '&.body': {
                            height: '18px',
                        },
                        '&.smallbody': {
                            height: '15px',
                        },
                        '&.circle': {
                            borderRadius: '50%',
                            width: '64px',
                            height: '64px',
                        },
                        '&.square': {
                            width: '64px',
                            height: '64px',
                        },
                    },
                },
            },
            MuiBadge: {
                styleOverrides: {
                    root: {
                        '& .MuiBadge-badge': {
                            position: 'relative',
                            transform: 'none',
                        },
                        '& .MuiBadge-dot': {
                            position: 'absolute',
                            border: '1px solid white',
                        },
                    },
                },
                defaultProps: {
                    color: 'black',
                    showZero: true,
                    badgeContent: ' ',
                    anchorOrigin: {
                        vertical: 'top',
                        horizontal: 'right',
                    },
                },
            },
            MuiLinearProgress: {
                styleOverrides: {
                    colorPrimary: {
                        backgroundColor: colorPalette.red200,
                    },
                    bar1Indeterminate: {
                        backgroundColor: colorPalette.red500,
                    },
                    bar2Indeterminate: {
                        backgroundColor: colorPalette.red500,
                    },
                    bar1Determinate: {
                        backgroundColor: colorPalette.red500,
                    },
                },
            },
            MuiCircularProgress: {
                styleOverrides: {
                    determinate: {
                        color: colorPalette.red700,
                    },
                },
                defaultProps: {
                    disableShrink: true,
                    sx: {
                        '&.MuiCircularProgress-indeterminate': {
                            content: `url('data:image/svg+xml;utf8, <svg xmlns="http://www.w3.org/2000/svg" viewBox="22 22 44 44">\
            <linearGradient id="gradient" x1="100%" y1="0%" x2="0%" y2="0%">\
              <stop offset="0%" stop-color="rgba(216, 0, 0, 0)" />\
              <stop offset="0.04%" stop-color="rgba(191, 0, 0, 0)" />\
              <stop offset="100%" stop-color="rgb(216, 0, 0)" />\
            </linearGradient>\
            <circle cx="44" cy="44" r="20.2" fill="none" stroke-dasharray="80px 200px" stroke-dashoffset="0" stroke="url(%23gradient)" stroke-width="3.6px" stroke-linecap="round" />\
          </svg>')`,
                        },
                    },
                },
            },
            MuiSnackbar: {
                styleOverrides: {
                    root: {
                        maxWidth: '600px',
                        margin: '0 auto',
                        [`&.${snackbarClasses.root}`]: {
                            transform: 'none',
                            bottom: '16px',
                            '@media (min-width: 320px)': {
                                bottom: '32px',
                            },
                            left: '16px',
                            right: '16px',
                            '& > div:first-child': {
                                borderRadius: '5px',
                                boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.14), 0px 4px 5px rgba(0, 0, 0, 0.12), 0px 1px 10px rgba(0, 0, 0, 0.2)',
                            },
                        },
                        [`& .${paperClasses.root}`]: {
                            padding: '4px 12px',
                            [`& .${alertClasses.icon}`]: {
                                marginTop: '9px',
                            },
                        },
                        [`& .${svgIconClasses.root}`]: {
                            color: colorPalette.white,
                            width: 16,
                            height: 16,
                        },
                        [`& .${alertClasses.standardInfo}`]: {
                            color: colorPalette.white,
                            backgroundColor: colorPalette.gray900,
                            [`& .${alertClasses.icon}`]: {
                                display: 'none',
                            },
                        },
                        [`& .${alertClasses.standardSuccess}`]: {
                            color: colorPalette.white,
                            backgroundColor: colorPalette.green700,
                        },
                        [`& .${alertClasses.standardError}`]: {
                            color: colorPalette.white,
                            backgroundColor: colorPalette.red600,
                        },
                    },
                },
                defaultProps: {
                    anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'center',
                    },
                    TransitionComponent: Slide,
                },
            },
            MuiPopover: {
                styleOverrides: {
                    paper: {
                        [`& .${listClasses.root} > .${menuItemClasses.root}.Mui-selected`]: {
                            backgroundColor: colorPalette.gray200,
                        },
                        boxShadow: '0px 4px 16px 0px rgba(0, 0, 0, 0.12)',
                        '& ul': {
                            maxHeight: '200px',
                            '& li': {
                                height: '48px',
                            },
                        },
                    },
                },
            },
            MuiPopper: {
                styleOverrides: {
                    root: {
                        [`& .${paperClasses.root} > .${calendarOrClockPickerClasses.root}`]: {
                            translate: '40px 0px',
                        },
                        [`& .${pickersPopperClasses.paper}`]: {
                            backgroundColor: 'transparent',
                        },
                    },
                },
            },
            MuiPaper: {
                styleOverrides: {
                    root: {
                        [`& .${calendarOrClockPickerClasses.root}`]: {
                            maxHeight: '370px',
                            backgroundColor: colorPalette.white,
                            marginTop: '4px',
                            boxShadow: `1px 4px 5px 0px ${colorPalette.gray200}, 1px 2px 4px 0px ${colorPalette.gray200}`,
                            borderRadius: '12px',
                            '& > div': {
                                maxHeight: '370px',
                            },
                        },
                        [`& .${calendarPickerClasses.root}`]: {
                            maxHeight: '370px',
                            marginTop: '10px',
                            [`& .${calendarPickerClasses.viewTransitionContainer}`]: {
                                '& .Mui-selected': {
                                    backgroundColor: colorPalette.gray700,
                                },
                            },
                        },
                    },
                },
            },
            MuiStepper: {
                styleOverrides: {
                    root: {
                        padding: '0px',
                        [`& .${stepLabelClasses.root}`]: {
                            padding: 0,
                        },
                    },
                },
            },
            MuiStep: {
                styleOverrides: {
                    horizontal: {
                        [`& .${stepContentClasses.root}`]: {
                            borderLeft: 0,
                            margin: 0,
                            padding: 0,
                            textAlign: 'center',
                        },
                    },
                    vertical: {
                        ['&.Mui-completed']: {
                            [`& .${stepContentClasses.root}`]: {
                                borderLeft: `2px solid ${colorArray.main}`,
                            },
                        },
                        ['&.Mui-active']: {
                            [`& .${stepContentClasses.root}`]: {
                                borderLeft: `2px solid ${colorArray.main}`,
                            },
                        },
                    },
                },
            },
            MuiStepConnector: {
                styleOverrides: {
                    root: {},
                    vertical: {
                        ['&.Mui-completed']: {
                            [`& .${stepConnectorClasses.line}`]: {
                                borderLeft: `2px solid ${colorArray.main}`,
                            },
                        },
                        ['&.Mui-active']: {
                            [`& .${stepConnectorClasses.line}`]: {
                                borderLeft: `2px solid ${colorArray.main}`,
                            },
                        },
                    },
                    horizontal: {
                        top: 10,
                        marginLeft: 0,
                        left: 'calc(-50% + 10px)',
                        right: 'calc(50% + 10px)',
                        ['&.Mui-completed']: {
                            [`& .${stepConnectorClasses.line}`]: {
                                border: `1px solid ${colorArray.main}`,
                            },
                        },
                        ['&.Mui-active']: {
                            [`& .${stepConnectorClasses.line}`]: {
                                border: `1px solid ${colorArray.main}`,
                            },
                        },
                    },
                    lineHorizontal: {
                        border: `1px solid ${colorPalette.gray200}`,
                    },
                    lineVertical: {
                        borderLeft: `2px solid ${colorPalette.gray200}`,
                    },
                },
            },
            MuiStepContent: {
                styleOverrides: {
                    root: {
                        marginTop: '-2px',
                        fontWeight: 600,
                        color: colorPalette.gray900,
                    },
                    transition: {
                        visibility: 'visible',
                        height: '100% !important',
                        overflow: 'visible',
                    },
                },
            },
            MuiMobileStepper: {
                styleOverrides: {
                    root: {
                        padding: '0px',
                    },
                    dot: {
                        backgroundColor: colorPalette.gray300,
                    },
                    dotActive: {
                        backgroundColor: colorArray.main,
                    },
                    progress: {
                        width: '100%',
                        backgroundColor: colorArray.backgroundTextHover,
                        [`& .${linearProgressClasses.bar}`]: {
                            backgroundColor: colorArray.secondary,
                        },
                    },
                },
            },
        },
    };
    return createTheme(theme);
};
